/* eslint @typescript-eslint/ban-ts-comment: */

// @ts-nocheck

import axios from 'axios'
import isEmpty from 'lodash/isEmpty'

export const getWebcastCommunities = (channelId, webcastId, host = '', BTSESSION) => {

  const headers: {
    Accept: string
  } = {
    Accept: 'application/json'
  }

  if (BTSESSION) {

    headers['cache-control'] = 'no-cache'
  }

  return axios.get(`${host}/service/community/v1?channelId=${channelId}&webcastId=${webcastId}`, {
    headers
  })
    .then(({ data }) => data)
}
export const getChannelCommunities = (channelId, host = '', BTSESSION) => {

  const headers: {
    Accept: string
  } = {
    Accept: 'application/json'
  }

  let url = `/service/community/v1?channelId=${channelId}`
  if (BTSESSION) {

    headers['cache-control'] = 'no-cache'
    url = `${host}/service/community/v1?channelId=${channelId}`
  }

  return axios.get(url, {
    headers
  })
    .then(({ data }) => data)
}

export const setWebcastCommunities = (channelId, webcastId, communitiesArr, host = '') =>

  axios.put(`/service/community/v1?channelId=${channelId}&webcastId=${webcastId}`, communitiesArr)
    .then(() => ({ channelId, webcastId }))

export const setChannelCommunities = (channelId, communitiesArr, host = '') =>

  axios.put(`/service/community/v1?channelId=${channelId}`, communitiesArr)
    .then(() => ({ channelId }))

export const getAllCommunities = (host = '', BTSESSION, query: boolean) => {

  const headers: {
    Accept: string,
    Cookie?: string,
    withCredentials?: boolean
  } = {
    Accept: 'application/json'
  }

  let url = !query ? `/service/community/v1/communities` : `/service/community/v1/communities?enabled=true&depth=2`

  if (BTSESSION) {

    headers.Cookie = 'BTSESSION=' + encodeURIComponent(BTSESSION)
    headers['cache-control'] = 'no-cache'
    url = !query ? `${host}/service/community/v1/communities` : `${host}/service/community/v1/communities?enabled=true&depth=2`
 
  } else {
 
    headers.withCredentials = true
 
  }

  return axios.get(url, {
    headers
  })
    .then(({ data }) => data)
}

export const getChannelAllCommunities = (communities) => {

  let allChannelCommunities = []

  communities.forEach((community, index) => {

    if (community.children) {
      community.children.forEach((communityItem, key) => {
        allChannelCommunities.push({
          ...communityItem,
          title: communityItem.title,
        })
      })
    }

  })

  return allChannelCommunities
}

export const getChannelPrimaryCommunity = (communities) => {

  let allChannelCommunities = []
  allChannelCommunities = getChannelAllCommunities(communities)

  let primaryCommunity = allChannelCommunities.find(({primary}) => primary === true )

  return primaryCommunity
}

export const getChannelPrimaryCommunityName = (communities) => {

  let primaryCommunity = getChannelPrimaryCommunity(communities)
  
  return !isEmpty(primaryCommunity) ? primaryCommunity.title : ''
}

export const getChannelPrimaryCommunityEnabled = (communities) => {

  let primaryCommunity = getChannelPrimaryCommunity(communities)
  
  return !isEmpty(primaryCommunity) && primaryCommunity.enabled === true ? true : false
}

export const getChannelSecondaryCommunities = (communities) => {

  let allChannelCommunities = []
  allChannelCommunities = getChannelAllCommunities(communities)

  let secondaryCommunities = allChannelCommunities.filter(({primary}) => primary === false )

  return secondaryCommunities
}

export const getChannelSecondaryCommunitiesName = (communities) => {

  let secondaryCommunities = getChannelSecondaryCommunities(communities)
  let secondaryCommunitiesName = !isEmpty(secondaryCommunities) && secondaryCommunities.map(community => community.title)
  
  return secondaryCommunitiesName && secondaryCommunitiesName.join(", ")
}

export const getChannelSecondaryCommunitiesIds = (communities) => {

  let secondaryCommunities = getChannelSecondaryCommunities(communities)
  let secondaryCommunitiesId = !isEmpty(secondaryCommunities) && secondaryCommunities.map(community => community.id)
  
  return secondaryCommunitiesId && secondaryCommunitiesId.join(", ")
}

export const getChannelSecondaryCommunitiesEnabled = (communities) => {

  let secondaryCommunities = getChannelSecondaryCommunities(communities)
  let secondaryCommunitiesEnabled = !isEmpty(secondaryCommunities) && secondaryCommunities.filter(community => community.enabled === true)
  
  return !isEmpty(secondaryCommunitiesEnabled) ? true : false
}

export const getCommunityOptions = (allCommunities) => {
  let communityOptions = []

  allCommunities.forEach((community, index) => {

    let communityObj = {
      key: community.title,
      value: community.id,
      label: community.title,
      isDisabled: true,
      isTitle: true
    }

    communityOptions.push(communityObj)

    if (community.children) {

      community.children.forEach((communityItem, key) => {

        let childCommunity = {
          key: communityItem.title,
          value: communityItem.id,
          label: communityItem.title
        }

        communityOptions.push(childCommunity)
      
      })
    
    }

  })

  return communityOptions
}